import {useMemo, useRef} from "react";
import {Marker} from "react-leaflet";

// Hack to fix the marker icon issue https://github.com/PaulLeCam/react-leaflet/issues/453#issuecomment-761806673
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const defaultOnDragEnd = f => f;

const DraggableMarker = ({lat, lng, onDragEnd = defaultOnDragEnd}, disable) => {
    const markerRef = useRef(null)

    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker != null) {
                    const position = marker.getLatLng();
                    onDragEnd(position);
                }
            },
        }),
        [onDragEnd],
    )

    return (
        <Marker draggable={!disable}
                eventHandlers={eventHandlers}
                position={[lat, lng]}
                ref={markerRef}>
        </Marker>
    )
}

export default DraggableMarker;